<template>
  <div id="app">
    <Nav></Nav>

    <main class="page-wrapper content" :style="{ 'margin-top': marginTop }">
      <div class="d-none d-lg-block" :style="{ 'padding-top': paddingTop }"></div>
      <slot></slot>
    </main>

    <Footer></Footer>

    <div v-if="env == 'dev' || env == 'stage'" class="snackbar">
      YOU ARE CURRENTLY IN A TESTING ENVIRONMENT.
      TO GO TO PRODUCTION, <a style="all: unset; color: black;" href="https://networks.resonancehealth.org/networks">CLICK HERE</a>
    </div>
  </div>
</template>
<script>
const Footer = () => import('./Footer.vue');
const Nav = () => import('@/views/layouts/nav/Nav.vue');
import { mapState } from 'vuex';
import split from 'lodash/split';

export default {
  name: 'DefaultLayout',
  components: {
    Footer,
    Nav,
  },
  props: {
    showSubNav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env: process.env.VUE_APP_ENV,
    };
  },
  computed: {
    marginTop() {
      let top = 75; // base margintop
      let path = split(this.$route.fullPath, '/');
      if (path[1] == '404' || path[1] == 'unauthorized') {
        top = -75;
      }
      //let subNavHeight = 50;
      let maintenanceHeight = 40;

      if (this.maintenance) top += maintenanceHeight;

      //if (this.showSubNav) top += subNavHeight;

      return top.toString() + 'px !important';
    },
    paddingTop() {
      let top = 0;
      if (this.maintenance) {
        if (
          this.$route.name == 'network-home' ||
          this.$route.name == 'network-page' ||
          this.$route.name == 'networks-members' ||
          this.$route.name == 'networks-messages' ||
          this.$route.name == 'networks-dashboard' ||
          this.$route.name == 'networks-meetings' ||
          this.$route.name == 'network_media' ||
          this.$route.name == 'network_collection'
        ) {
          top += 40;
        }
      }
      return top.toString() + 'px !important';
    },
    ...mapState({
      maintenance: (state) => state.maintenance,
    }),
  },
};
</script>
<style scoped>
.content {
  min-height: 100vh;
}
.show-nav-only {
  margin-top: 85px;
}
.show-nav-and-subnav {
  margin-top: 120px;
}
.snackbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgb(15 77 139 / 80%);;
  color: #fff;
  text-align: center;
  padding: 10px;
  z-index: 1000;
  font-size: 18px;
  font-weight: 600;
}
@media (max-width: 500px) {
  .page-wrapper .content {
    margin-top: -50px;
  }
}
</style>
